import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

type Params = { id: string; isProposal: number }

const loadOrderActions = (params: Params): any => {
  return axios.get(`/orders/actions/${params.id}`, { params })
}

export function useLoadOrderActions(params: Params) {
  return useQuery(['orderActions', params], () => loadOrderActions(params), {
    enabled: !!params.id,
    onError: () =>
      toast.error('Não foi possível carregar as ações!', {
        toastId: 'orderActions'
      })
  })
}
